import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import HomePage from "./components/Pages/HomePage";
import MainPage from "./components/Pages/MainPage";
// import axios from "axios";
import PairingPage from "./components/Pages/PairingPage";

const router = createBrowserRouter([
  { path: "/", element: <MainPage /> },
  { path: "/pairing/", element: <PairingPage />},
  { path: "/pairing/:param", element: <PairingPage />},
  // { path: "/:param", element: <PairingPage /> },
  {},
]);

function App() {
  return (
  <RouterProvider router={router} />
  );
}

export default App;
